module.exports = __webpack_public_path__ + "img/3-01-05-b-wht.38b4672c.svg";